import { t } from '@/core/localization';
export function getAccessDeniedMessage(result) {
    return result?.errorMessage
        ? result.errorMessage
        : result?.unaccessibleCrossDockId
            ? t('no.access.to.crossdock') + ` ${result.unaccessibleCrossDockId}`
            : result?.unaccessibleLocationId
                ? t('no.access.to.stock.location') + ` ${result.unaccessibleLocationId}`
                : undefined;
}
